import adminSchema from "./adminSchema.json";

/**
 * @typedef {import("./conditions").FlagDescriptor & { section: string, group?: string }} BooleanFlagDescriptor
 */

/**
 * Every plain boolean `app.flags.<key>` toggle rendered in the searchable feature-flag accordion
 * at the top of RfAdmin. Declared as JSON (`adminSchema.json`'s `accordionFlags`) so the schema
 * can eventually be handed off to the backend team and served from an API instead of shipped
 * with the frontend bundle — this module is just the current stand-in for that.
 *
 * `section` is the feature-group card it renders under; `group` is an optional sub-heading
 * within that card (e.g. Ingest & Devices' "Recurly auto ingest" grouping).
 *
 * A section with its own dedicated card (e.g. Bloom Filters) lives in `adminSchema.json`'s
 * `sections` instead, bundled with its title/description and non-boolean fields rather than
 * split out here — see `adminSections.js`.
 *
 * Deliberately out of scope: toggles backed by `app.feature_set` membership rather than a
 * `flags` key — it doesn't live at `flags.<key>`. `app.path_filter` toggles (e.g. Users Limits)
 * aren't out of scope anymore — they're declared in `adminSchema.json`'s `sections` with
 * `"source": "path_filter"` instead, since a section field can bind to a non-flags root; see
 * `adminSections.js`.
 *
 * @type {BooleanFlagDescriptor[]}
 */
export const BOOLEAN_FLAGS = adminSchema.accordionFlags;
